import { isMobile } from './js-helpers.js';
import { handleVideos } from './js-videos.js';

/* Credits
======================================== */
console.log('SIAN: code by Carlos Mayo (https://carlosmayo.info/)');

/* Device detection
======================================== */
document.body.classList.add(isMobile ? 'devices' : 'desktop');

/* :active listener
======================================== */
isMobile && document.addEventListener('touchstart', () => {}, { passive: true })

/* Reset scroll
======================================== */
history.scrollRestoration = 'manual';
window.scrollTo({ top: 0, behavior: 'auto' });

/* Loader
======================================== */
setTimeout(() => document.getElementById('loader')?.classList.add('completed'), 500);

/* Observer: videos
======================================== */
handleVideos.initObserver();
